import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { getRemoteMedia } from "utils/getRemoteMedia"
import { getPlatformURL } from "utils/helpers"

import CardBgAdornment from "../SuraasaCertificateCard/assets/CardBgAdornment.webp"
import baseStyles from "../SuraasaCertificateCard/SuraasaCertificateCard.module.css"
import styles from "./MEdDegreeCard.module.css"

const MEdDegreeCard = ({ serialNumber }: { serialNumber?: string | null }) => {
  const hasDegree = !!serialNumber
  const DynamicComponent = hasDegree ? "a" : "div"

  return (
    <DynamicComponent
      href={getPlatformURL("itu", `/verify/${serialNumber}`)}
      target="_blank"
      rel="noreferrer"
    >
      <div
        className={clsx(
          styles.root,
          "relative z-10 my-3 overflow-hidden rounded-2xl p-3",
          {
            [styles.hoverAnimation]: hasDegree,
          }
        )}
      >
        {hasDegree && (
          <img
            id="rings"
            src={CardBgAdornment}
            alt="bg"
            className={clsx(
              baseStyles.rotate,
              "absolute bottom-px right-0 -z-10 h-full"
            )}
          />
        )}
        <img
          src={`${getRemoteMedia("/logos/itu/default-light.png", {
            width: 160,
          })}`}
          height={30}
          width={80}
          alt="ITU"
          className="mb-2 sm:mb-1"
        />
        <span className={clsx("block", baseStyles.gradientText)}>
          Master&apos;s in Education Degree
        </span>
        {hasDegree ? (
          <Button className={clsx("mt-1.5", baseStyles.viewBtn)} size="sm">
            View Degree
          </Button>
        ) : (
          <Typography variant="smallBody" className="mt-1.5 text-white">
            You will earn this Degree automatically after you complete
            Master&apos;s In Education.
          </Typography>
        )}
      </div>
    </DynamicComponent>
  )
}

export default MEdDegreeCard
